<h3 *ngIf="data == null" modal-title>Cadastrar Assunto da Lista de Atividades</h3>
<h3 *ngIf="data != null" modal-title>Alterar Assunto da Lista de Atividades</h3>

<div modal-body  mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Nome</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    required
                    maxlength="255"
                />
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
        <br>
        <div fxFlex.gt-sm="100%" style="margin-top: 10px;margin-bottom: 10px;">
            <section>
                <mat-slide-toggle [checked]="model.is_visible" (change)="changeVisible($event)">
                    Atividades relacionadas a este assunto serão <br> visíveis para outros perfis?
                </mat-slide-toggle>
            </section>
        </div>
        <br>
        <div fxFlex.gt-sm="100%" style="margin-top: 10px;margin-bottom: 10px;">
            <section>
                <mat-slide-toggle [checked]="model.is_subject_prosperidade" (change)="changeIsSubjectProsperidade($event)">
                    É um assunto Prosperidade?
                </mat-slide-toggle>
            </section>
        </div>
        <br>
    </div>
</div>

<div mat-dialog-actions model-footer>
    
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   
        Cancelar
    </button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>


